<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> تعداد سفر به تفکیک جایگاه سازمانی </span>

    </div>

</div>

<form class="rtl  w-100 row gx-2 gy-2 mt-2 p-2" [formGroup]="searchModel">

    <div class="col-12 col-md-2 position-relative">

        <label> از تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control  " />

        </ng-persian-datepicker>

    </div>

    <div class="col-12 col-md-2 position-relative">

        <label> تا تاریخ </label>

        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

            <input type="text" formControlName="strEDate" placeholder="تا تاریخ" class="form-control" />

        </ng-persian-datepicker>

    </div>

    <div class="col-12 col-md-2 d-flex align-items-center">

        <button class="btn w-100 btn-primary" (click)="search_BaseChart()" > 
        
            &nbsp; جستجو &nbsp;
            
        </button>

    </div>

</form>

<main  class="rtl p-2">

    <span class="mx-2" *ngIf="list_BaseChart.length > 0"> تعداد <span class="text-danger fw-bold">{{list_BaseChart.length | faNum}}</span> مورد یافت شد </span>

    <div class="mt-3 border border-2 ">

        <div class="row gx-2 gy-2">

            <div [ngClass]="list_BaseChart.length > 0 ? 'col-md-10' : 'col-12' " class="p-3" >

                <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">
    
            </div>
    
            <div *ngIf="list_BaseChart.length > 0" class="col-12 col-md-2 p-3 text-end">
    
                <button class="btn btn-success" (click)="exportExcel()">
    
                    <span> خروجی اکسل </span>
    
                    <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
    
                </button>
                
            </div>

        </div>

        <div class="table-responsive " style="max-height: 74vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th> # </th>

                        <th> تاریخ  </th>

                        <th> جایگاه   </th>

                        <th> تعداد سفر   </th>

                    </tr>

                </thead>

                <tbody>

                    <ng-container *ngFor="let item of list_BaseChart;let i = index;">

                        <tr class="col-12 text-center">

                            <td>{{ i + 1 | faNum}}</td>

                            <td>{{item.strRequestDate | faNum}}</td>

                            <td>{{item.strComment | faNum}}</td>

                            <td>{{item.iCount | faNum}}</td>

                        </tr>

                    </ng-container>

                </tbody>

            </table>

        </div>

    </div>

</main>